import { tv, type VariantProps } from "tailwind-variants";

export const sideMenuVariant = tv({
  slots: {
    base: ["sticky", "top-18", "flex-col", "shrink-0", "w-73", "h-full"],
    wrapper: [
      "h-full",
      "max-h-[calc(100dvh-72px)]",
      "p-4",
      "overflow-y-auto",
      "mobile:pt-2",
      "desktop:p-10",
    ],
    headerMobile: ["flex", "items-center", "gap-2", "w-full", "mb-4", "desktop:hidden"],
    nav: ["flex", "flex-col", "gap-4", "w-full", "min-h-full"],
    title: ["text-static-black", "dark:text-white", "mobile:hidden"],
    titleMobile: [
      "text-static-black",
      "dark:text-white",
      "font-demibold",
      "text-5",
      "text-neutral-12",
      "desktop:hidden",
    ],
    menu: ["flex", "flex-col", "gap-2", "w-full"],
    dropdownTrigger: [
      "flex",
      "items-center",
      "justify-between",
      "w-full",
      "py-2",
      "px-3",
      "rounded-md",
      "hover:bg-surface-neutral-soft",
    ],
    dropdownTriggerIcon: ["w-4", "h-4"],
    dropdown: ["flex", "flex-col", "overflow-hidden"],
    dropdownItem: [
      "flex",
      "items-center",
      "justify-between",
      "w-full",
      "py-2",
      "px-3",
      "pl-6",
      "rounded-md",
      "text-neutral-soft",
      "transition-all",
      "duration-300",
      "ease-in-out",
      "hover:text-neutral-default aria-[current=true]:text-neutral-default",
      "hover:bg-surface-neutral-soft aria-[current=true]:bg-surface-neutral-soft",
    ],
  },
  variants: {
    isMobileMenu: {
      true: {
        base: [
          "flex",
          "fixed",
          "inset-0",
          "top-[72px]",
          "z-50",
          "w-full",
          "h-[100dvh]",
          "bg-white",
          "dark:bg-black",
        ],
      },
      false: {
        base: ["hidden", "desktop:flex"],
      },
    },
  },
  defaultVariants: {},
});

export type SideMenuVariantProps = VariantProps<typeof sideMenuVariant>;
export type SideMenuReturnVariantProps = ReturnType<typeof sideMenuVariant>;
